import React from 'react';
import Chart from 'react-apexcharts';
import GraphLoader from './GraphLoader';

const PieChartComponent = ({ data }) => {
    const loading = !data?.length;

    if (loading) {
        return <GraphLoader />;
    }

    const options = {
        chart: {
            type: 'pie',
            height: 364,
            animations: { enabled: false },
            dropShadow: { enabled: true, opacity: 0.1, blur: 7, left: -7, top: 7 },
            toolbar: { show: true },
            parentHeightOffset: 0,
        },
        labels: data.map((d) => d.name),
        legend: { position: 'top', horizontalAlign: 'center' },
    };

    const series = data.map((d) => d.value);

    return <Chart options={options} series={series} type="pie" className="apex-charts mt-3" height={378} />;
};

export default PieChartComponent;
